
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BookOpen, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ServiceDescriptionCardProps {
  description: string;
}

const ServiceDescriptionCard: React.FC<ServiceDescriptionCardProps> = ({
  description
}) => {
  const { t } = useTranslation();
  
  const hasDescription = description && description.trim().length > 0;

  return (
    <Card className="bg-gradient-to-br from-white to-gray-50/30 border shadow-sm hover:shadow-md transition-all duration-300">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-semibold text-gray-900 leading-none flex items-center gap-2">
          {t('service.details.about')}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {hasDescription ? (
          <div className="prose prose-sm max-w-none">
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {description}
            </p>
          </div>
        ) : (
          <div className="text-center py-8 space-y-4">
            <div className="w-12 h-12 mx-auto bg-primary/10 rounded-full flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-primary" />
            </div>
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">
                {t('service.details.no_description_placeholder')}
              </p>
              <p className="text-xs text-muted-foreground italic">
                {t('service.details.description_coming_soon')}
              </p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ServiceDescriptionCard;
